import React from "react";
import "./Footer.css";

class Footer extends React.Component{
    render(){
        return (
            <div className="Footer">
            Designed and built by Bayley Sapara 2024, Last updated 2026
            <br></br>   
            Made with React 
            <br></br>    
            <br></br>
            Art Attributions:
            <br></br>
            <a href="https://www.flaticon.com/free-icons/embed" title="embed icons">Embed icons created by IconMarketPK - Flaticon</a>
              
            </div>
        )
    }
}

export default Footer;